import type { MutableRefObject } from 'react'
import { SurveyAnswerList } from '@coorum-research/core/src/components/SurveyAnswerList'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { answerApi } from '../apis/answers.api'
import { campaignApi } from '../apis/campaign.api'
import { AnswerDetailUpdateSheet } from './AnswerDetailUpdateSheet'

type Props = {
  answerId: string
  containerRef: MutableRefObject<HTMLDivElement | null>
}

export function AnswerDetail({ containerRef, answerId }: Props) {
  const { getAnswerDetail } = answerApi()
  const { data: answerDetail, isFetched } = useQuery({
    queryKey: ['get-answer-detail', answerId],
    queryFn: () => getAnswerDetail(answerId),
  })

  const [isSheetOpen, setSheetOpen] = useState(false)

  const { getCampaign } = campaignApi()
  const { data: campaign, isFetched: isCampaignFetched } = useQuery({
    queryKey: ['get-campaign-answer-detail', answerDetail?.campaignId],
    queryFn: async () => {
      if (!answerDetail?.campaignId) {
        return
      }
      return await getCampaign(answerDetail.campaignId)
    },
    enabled: !!answerDetail?.campaignId && isSheetOpen,
  })

  /**
   * アンケート修正を開始する
   */
  const handleEditStart = () => {
    setSheetOpen(true)
  }

  const queryClient = useQueryClient()
  /**
   * アンケート修正を終了（完了）する
   */
  const handleEditClose = () => {
    setSheetOpen(false)
    void queryClient.invalidateQueries({ queryKey: ['get-answer-detail', answerId] })
  }

  return (
    <>
      {isFetched && answerDetail && (
        <>
          <SurveyAnswerList
            surveyName={answerDetail.surveyName}
            createdAt={answerDetail.createdAt}
            surveyConfig={answerDetail.surveyConfig}
            surveyThemeConfig={answerDetail.surveyThemeConfig}
            surveyAnswer={answerDetail.surveyAnswer}
            thanksContentName={answerDetail.thanksContentName}
            thanksContentConfig={answerDetail.thanksContentConfig}
            onEditStart={handleEditStart}
          />
          {isCampaignFetched && (
            <AnswerDetailUpdateSheet
              open={isSheetOpen}
              setOpen={handleEditClose}
              campaign={campaign}
              answerDetail={answerDetail}
              containerRef={containerRef}
            />
          )}
        </>
      )}
    </>
  )
}
